import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import { siteConfig } from "../Datas/productData";
import "../css/about.scss";

function About() {
  useEffect(() => {
    document.title = `Our Story | ${siteConfig.brandName}`;
  }, []);

  return (
    <main className="about">
      <header className="about__hero">
        <div className="page-width">
          <span className="eyebrow">Our story</span>
          <h1>Why {siteConfig.brandName}?</h1>
          <p>We make the things we want to wear: useful, honest and ready to become personal.</p>
          <div className="about__values" aria-label="Brand values">
            <span>Raw denim</span><span>Made with purpose</span><span>Highest quality</span><span>Lower impact</span><span>Authentic wear</span>
          </div>
        </div>
      </header>

      <section className="about__intro page-width">
        <div>
          <span className="about__number">01</span>
          <h2>What is selvedge?</h2>
        </div>
        <p>
          Selvedge is the tightly finished edge created when cloth is woven on a narrow shuttle loom. The slower process gives denim a compact edge and a distinctive, irregular surface. We value it for the same reason we value a well-made tool: it is direct, durable and reveals how it was made.
        </p>
      </section>

      <section className="about__feature page-width">
        <img src="/img/brand/hero-workshop.jpg" alt="A denim craftsperson working beside rolls of raw cloth" width="1942" height="809" />
        <div>
          <span className="about__number">02</span>
          <h2>What is raw denim?</h2>
          <p>
            Raw denim arrives without the factory washing and artificial distressing used to imitate age. It starts dark and crisp, then relaxes, creases and fades according to the wearer’s own routine. No two pairs finish the same way.
          </p>
          <blockquote>“The best-looking pair is the one you actually lived in.”</blockquote>
        </div>
      </section>

      <section className="about__chapters">
        <div className="page-width">
          <article>
            <span>03</span>
            <h2>Made in the home of blue jeans</h2>
            <p>Our point of view comes from San Francisco: port city, workshop town and birthplace of blue-jean culture. We work close to the people who cut, sew and finish our garments because proximity makes every decision more accountable.</p>
          </article>
          <article>
            <span>04</span>
            <h2>Highest quality</h2>
            <p>Cost per wear matters more than novelty. Strong pocketing, balanced patterns and repairable construction are not marketing details — they are the difference between something kept and something replaced.</p>
          </article>
          <article>
            <span>05</span>
            <h2>Environmental factors</h2>
            <p>Skipping industrial pre-washing avoids the water, stones, chemicals and energy used to fake years of wear. We prefer fewer processes and longer product lives, then washing only when the garment truly needs it.</p>
          </article>
          <article>
            <span>06</span>
            <h2>Authentic break-in and fit</h2>
            <p>Unprocessed cotton responds to the body much like good leather footwear. The cloth softens at pressure points and keeps a record of movement. The result is not a trend effect; it is an honest fit earned over time.</p>
          </article>
        </div>
      </section>

      <section className="about__founders page-width">
        <div>
          <span className="eyebrow">The makers</span>
          <h2>Small by choice. Serious about the work.</h2>
          <p>
            {siteConfig.brandName} began with a simple conviction: make one excellent pair of jeans and stand behind it. That still guides every fabric, fit and finishing decision today.
          </p>
          <p>
            The workshop remains deliberately close-knit. It lets us listen, refine a pattern instead of replacing it, and help customers keep good clothes in service.
          </p>
          <Link className="button button--accent" to="/shop">Explore the collection <FiArrowRight /></Link>
        </div>
        <img src="/img/brand/story-makers.jpg" alt="Two makers checking denim construction in a small workshop" width="1448" height="1086" />
      </section>
    </main>
  );
}

export default About;
